import { Button, ChoiceChips } from '@hue/design-system';
import { ChevronDown, ClipboardCheck, NotebookPen } from 'lucide-react';
import { useId, useState, type ReactNode } from 'react';

export function AppointmentLayoutToggle({
  layout,
  onChange,
  saving,
}: {
  layout: 'columns' | 'stacked';
  saving: boolean;
  onChange: (layout: 'columns' | 'stacked') => void;
}) {
  return (
    <fieldset disabled={saving} className="min-w-0" aria-busy={saving}>
      <p className="mb-2 text-xs font-semibold text-content-muted">Organização do atendimento</p>
      <ChoiceChips
        label="Organização do atendimento"
        options={[
          { value: 'columns', label: 'Lado a lado' },
          { value: 'stacked', label: 'Etapas verticais' },
        ]}
        value={layout}
        onChange={(value) => onChange(value as 'columns' | 'stacked')}
      />
    </fieldset>
  );
}

export function AppointmentPhase({
  phase,
  children,
}: {
  phase: 'before' | 'after';
  children: ReactNode;
}) {
  const id = useId();
  const [open, setOpen] = useState(true);
  const Icon = phase === 'before' ? ClipboardCheck : NotebookPen;
  const title = phase === 'before' ? 'Pré-atendimento' : 'Pós-atendimento';
  return (
    <section aria-labelledby={`${id}-title`} className="grid min-w-0 gap-4">
      <h2 id={`${id}-title`}>
        <Button
          variant="outline"
          className="w-full justify-between"
          aria-expanded={open}
          aria-controls={`${id}-content`}
          onClick={() => setOpen(!open)}
        >
          <span className="inline-flex items-center gap-2">
            <Icon aria-hidden="true" className="size-4 text-brand-400" />
            {title}
          </span>
          <ChevronDown aria-hidden="true" className={`size-4 ${open ? 'rotate-180' : ''}`} />
        </Button>
      </h2>
      {/* Recolher e mudar a organização preservam os formulários e seus rascunhos. */}
      <div id={`${id}-content`} hidden={!open} className="grid min-w-0 gap-6">
        {children}
      </div>
    </section>
  );
}
